import { fabric } from 'fabric';

export const showMagicFrameCustomControls = () => {
  fabric.MagicFrame.prototype.controls.replacePhoto.setVisibility(true);
  fabric.MagicFrame.prototype.controls.modifyPhoto.setVisibility(true);
};
